export enum FileErrorCodeEnum {
    LIVENESS_CHECK_FAILED = 5000,
    DEEPFAKE_DETECTED = 5001,
    SPOOFING_DETECTED = 5002,
    FACE_TOO_FAR = 5003,
    POOR_LIGHTING_CONDITIONS = 5004,
    FACE_VIDEO = 5005,
    FACE_TOO_SMALL = 5006,
    FACE_IMAGE = 5007,
    EYES_CLOSED = 5008,
    IMAGE_TOO_BLURRY = 5009,
    CAMERA_RESOLUTION_TOO_LOW = 5010,
    FOREHEAD_NOT_VISIBLE = 5011,
    CHIN_NOT_VISIBLE = 5012,
    TOO_BRIGHT = 5017,
    LIVENESS_HINT_5019 = 5019,
    FACE_PARTIALLY_COVERED = 5020,
    MASK_DETECTED = 5021,
    HAND_COVERING_FACE = 5022,
    HEADWEAR_COVERING_FACE = 5023,
    SUNGLASSES_DETECTED = 5024,
    LIMIT_UPLOADING = 'Limit for uploading files are exceeded',
    CONSENT_REQUIRED = 'consent_required',
}

/** Numeric BE codes that pause scanning and show a translated hint. */
export const LIVENESS_HINT_ERROR_CODES: readonly number[] = [
    FileErrorCodeEnum.FACE_TOO_FAR as number,
    FileErrorCodeEnum.POOR_LIGHTING_CONDITIONS as number,
    FileErrorCodeEnum.FACE_TOO_SMALL as number,
    FileErrorCodeEnum.EYES_CLOSED as number,
    FileErrorCodeEnum.IMAGE_TOO_BLURRY as number,
    FileErrorCodeEnum.CAMERA_RESOLUTION_TOO_LOW as number,
    FileErrorCodeEnum.FOREHEAD_NOT_VISIBLE as number,
    FileErrorCodeEnum.CHIN_NOT_VISIBLE as number,
    FileErrorCodeEnum.TOO_BRIGHT as number,
    FileErrorCodeEnum.LIVENESS_HINT_5019 as number,
    FileErrorCodeEnum.FACE_PARTIALLY_COVERED as number,
    FileErrorCodeEnum.MASK_DETECTED as number,
    FileErrorCodeEnum.HAND_COVERING_FACE as number,
    FileErrorCodeEnum.HEADWEAR_COVERING_FACE as number,
    FileErrorCodeEnum.SUNGLASSES_DETECTED as number,
];
